import { render, staticRenderFns } from "./info-document.vue?vue&type=template&id=59dec8ac&scoped=true&"
import script from "./info-document.vue?vue&type=script&lang=js&"
export * from "./info-document.vue?vue&type=script&lang=js&"
import style0 from "./info-document.vue?vue&type=style&index=0&id=59dec8ac&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59dec8ac",
  null
  
)

export default component.exports